<template>
    <div class="text-center roma-options">
        <v-menu
            bottom
            :close-on-click="closeOnClick"
            class="roma-options__menu"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn dark color="black" v-bind="attrs" v-on.stop="on" icon>
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
            </template>

            <v-list class="roma-options__list">
                <template v-for="(item, index) in getOptions">
                    <v-list-item
                        :key="index"
                        @click="item.action(activityId)"
                        v-if="item.status"
                        class="roma-options__list-items"
                    >
                        <v-list-item-icon class="roma-options__icon">
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                </template>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
export default {
    props: {
        options: Array,
        activityId: Number
    },
    methods: {},
    computed: {
        getOptions() {
            return this.options ? this.options : this.defaultOptions;
        }
    },
    data: () => ({
        closeOnClick: true,
        defaultOptions: [
            {
                title: "Default option",
                icon: "mdi-checkbox-blank-circle",
                status: true
            }
        ]
    })
};
</script>

<style lang="scss" scoped>
.v-menu__content {
    border-radius: 15px !important;
}
.roma-options {
    &__menu {
        border-radius: 15px;
    }
    &__list {
        width: 299px;
        height: 210px;
        background: #ffffff 0 0 no-repeat padding-box;
        box-shadow: 0 10px 20px #00000029;
        border-radius: 15px;
    }
    &__list-items {
        font-size: 14px;
        height: 20px;
        i {
            color: #e8e8e8;
        }
    }
    &__icon {
        min-width: 10px;
        max-width: 10px;
    }
}
</style>
